import React from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import styled from 'styled-components'
import theme from '../theme';
import Icon from '../Icon';
import CircularProgress from '../CircularProgress';
import { useTranslation } from 'react-i18next';
import { media } from '../../utils/media';

const sizes = { 'x-small':'26px', 'small': '32px', 'standard': '41px', 'xxl': '70px' }

const IconButtonStyled = styled(IconButton)`
  max-height: ${({ $size }) => sizes[$size] || sizes.standard};
  width: ${({ $size }) => sizes[$size] || sizes.standard};
  height: ${({ $size }) => sizes[$size] || sizes.standard};
  background-color: ${({ $bgColor }) => $bgColor} !important;
  display: ${({ $onlyMobile }) => $onlyMobile && 'none'} !important;
  ${media.lessThan('tablet')} {
    display:${({ $onlyMobile }) => $onlyMobile && 'inherit'} !important;
  }
`
const BadgeStyled = styled(Badge)`
  .MuiBadge-badge {
    background-color: ${({ badgecolor }) => badgecolor};
    color: ${(props) => props.theme.colors.NEU_0};
  }
`;

const IconAsButton = ({ 
  hasBadge, 
  badgeInfo, 
  iconName, 
  color, 
  clickHandle, 
  className, 
  disabled, 
  size, 
  tooltipLabel, 
  placement, 
  loading,
  progressValue,
  onlyMobile,
  noTooltip,
  bgColor 
}) => {
  const { t } = useTranslation();

  const badgeIcon = (Component, props) => {
    const { badgeInfo, hasBadge, color } = props
    return hasBadge ?
      <BadgeStyled badgeContent={badgeInfo} badgecolor={theme.colors.ACTION} >
        <Component color={color} />
      </BadgeStyled>
      : <Component color={color} size={size} />
  }

  const renderContent = () => {
    return (
      <IconButtonStyled 
        aria-label={iconName} 
        onClick={clickHandle} 
        className={className} 
        disabled={disabled} 
        $size={size}
        $onlyMobile={onlyMobile}
        $bgColor={bgColor}
      >
        {loading ? 
          <CircularProgress value={progressValue} size={20}/>
          : badgeIcon(Icon[iconName], { badgeInfo, iconName, hasBadge, color, size })
        }
      </IconButtonStyled>
    );
  }

  if (noTooltip) {
    return renderContent();
  }

  /** Material UI's Tooltip component doesn't work properly when its child has a disabled prop
   * We need to wrap the disabled buttons in a container, which doesn't have disabled prop. **/
  return (
    <Tooltip title={tooltipLabel || t(`icons.${iconName}`)} placement={placement || 'bottom'}>
      <span>
        {renderContent()}
      </span>
    </Tooltip >
  );
};

export default IconAsButton;
